import {
  TEMPLATE_TESTING_GUIDE_DEFAULT_TRAFFIC_SPLIT_RATIO,
  TEMPLATE_TESTING_GUIDE_STEPS_AMOUNT,
} from '~/modules/onboarding/modules/campaign-template/constants';

import { create } from 'zustand';

interface TemplateTestingGuideStoreState {
  currentStep: number | null;
  splitUserTrafficRangeValue: number;
}

interface TemplateTestingGuideStoreActions {
  setCurrentStep: (step: number) => void;
  nextStep: () => void;
  previousStep: () => void;
  setSplitUserTrafficRangeValue: (value: number) => void;
}

export const useTemplateTestingGuideStore = create<
  TemplateTestingGuideStoreState & TemplateTestingGuideStoreActions
>()((set) => ({
  currentStep: null,
  splitUserTrafficRangeValue: TEMPLATE_TESTING_GUIDE_DEFAULT_TRAFFIC_SPLIT_RATIO,

  setCurrentStep: (step: number) => set(() => ({ currentStep: step })),
  nextStep: () =>
    set(({ currentStep }) => ({
      currentStep:
        currentStep === null ? 1 : Math.min(currentStep + 1, TEMPLATE_TESTING_GUIDE_STEPS_AMOUNT),
    })),
  previousStep: () =>
    set(({ currentStep }) => ({
      currentStep: currentStep === null ? null : Math.max(currentStep - 1, 0),
    })),
  setSplitUserTrafficRangeValue: (value: number) =>
    set(() => ({ splitUserTrafficRangeValue: value })),
}));
